export const expiredInviteMsg =
  "Unfortunately, this invite link expired or no longer works.";

export const contactHelpMsg =
  "Contact the person who sent you this link for more information.";

export const tryAgainMsg =
  "Please try again. If you continue to experience this problem, please contact us.";
